import React from 'react'

const OrdersReport = () => {
  return (
    <div>OrdersReport</div>
  )
}

export default OrdersReport